// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colorPaletteContainer_rUM80 {
	display: flex;
	align-items: center;
	cursor: pointer;
	position: relative;
	width: 55px;
}

.colorPaletteContainer_rUM80:hover {
	background-color: var(--_16c0982e-background);
	border-radius: 8px;
}

.colorPalettePopup_gd1Pw {
	position: absolute;
	top: 30px;
	left: 0;
	background-color: var(--white-color);
	border-radius: 8px;
	box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
	padding: 10px;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 10px;
	z-index: 10;
}

.colorOption_EVJYz {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	padding: 2px;
	border-radius: 50%;
}

.colorOption_EVJYz:hover {
	background-color: var(--_16c0982e-background);
	border-radius: 50%;
}
.dot_g3bCi {
	width: 18px;
	height: 18px;
	border-radius: 50%;
}
.checkIcon_ygM0D {
	position: absolute;
	color: var(--white-color);
	font-size: 14px;
}

.tooltip_BU1Aq {
	position: absolute;
	top: -30px;
	left: 50%;
	transform: translateX(-50%);
	background-color: #333;
	color: var(--white-color);
	padding: 4px 8px;
	border-radius: 4px;
	font-size: 12px;
	white-space: nowrap;
}

.arrow_RXD21 {
	width: 0;
	height: 0;
	border-left: 4px solid transparent;
	border-right: 4px solid transparent;
	border-top: 4px solid #666;
	margin-left: 8px;
	transition: transform 0.2s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/CustomColorPalette.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,6CAA6C;CAC7C,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,oCAAoC;CACpC,kBAAkB;CAClB,0CAA0C;CAC1C,aAAa;CACb,aAAa;CACb,qCAAqC;CACrC,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,6CAA6C;CAC7C,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,2BAA2B;CAC3B,sBAAsB;CACtB,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,QAAQ;CACR,SAAS;CACT,kCAAkC;CAClC,mCAAmC;CACnC,0BAA0B;CAC1B,gBAAgB;CAChB,sCAAsC;AACvC","sourcesContent":[".colorPaletteContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tposition: relative;\n\twidth: 55px;\n}\n\n.colorPaletteContainer:hover {\n\tbackground-color: var(--_16c0982e-background);\n\tborder-radius: 8px;\n}\n\n.colorPalettePopup {\n\tposition: absolute;\n\ttop: 30px;\n\tleft: 0;\n\tbackground-color: var(--white-color);\n\tborder-radius: 8px;\n\tbox-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n\tpadding: 10px;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgap: 10px;\n\tz-index: 10;\n}\n\n.colorOption {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\tpadding: 2px;\n\tborder-radius: 50%;\n}\n\n.colorOption:hover {\n\tbackground-color: var(--_16c0982e-background);\n\tborder-radius: 50%;\n}\n.dot {\n\twidth: 18px;\n\theight: 18px;\n\tborder-radius: 50%;\n}\n.checkIcon {\n\tposition: absolute;\n\tcolor: var(--white-color);\n\tfont-size: 14px;\n}\n\n.tooltip {\n\tposition: absolute;\n\ttop: -30px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tbackground-color: #333;\n\tcolor: var(--white-color);\n\tpadding: 4px 8px;\n\tborder-radius: 4px;\n\tfont-size: 12px;\n\twhite-space: nowrap;\n}\n\n.arrow {\n\twidth: 0;\n\theight: 0;\n\tborder-left: 4px solid transparent;\n\tborder-right: 4px solid transparent;\n\tborder-top: 4px solid #666;\n\tmargin-left: 8px;\n\ttransition: transform 0.2s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorPaletteContainer": `colorPaletteContainer_rUM80`,
	"colorPalettePopup": `colorPalettePopup_gd1Pw`,
	"colorOption": `colorOption_EVJYz`,
	"dot": `dot_g3bCi`,
	"checkIcon": `checkIcon_ygM0D`,
	"tooltip": `tooltip_BU1Aq`,
	"arrow": `arrow_RXD21`
};
export default ___CSS_LOADER_EXPORT___;
